<div class="iubenda-padding">
  <div class="p-3 full-page-registration container-lg" cdkScrollable>
    <div class="col-sm-12 title mb-3">
      <div>
        <span>{{'COMPLETA_REGISTRAZIONE' | translate | uppercase}}</span>
      </div>
    </div>
    <div class="mb-3">
      <span>{{'DESCRIZIONE_COMPLETA_REGISTRAZIONE' | translate}}</span>
    </div>
    <div>
      <div class="row register-form">
        <div class="col-md-12">
          <form [formGroup]="registrationForm" class="form">
            <fieldset>
              <div class="row-form">
                <mat-form-field appearance="outline">
                  <mat-label>{{'EMAIL' | translate}}</mat-label>
                  <input formControlName="email"
                    type="email"
                    autocomplete="username"
                    email
                    matInput
                    required/>
                  @if (checkForm(registrationForm, 'email'); as err) {
                    <mat-error>
                      {{err}}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row-form">
                <mat-form-field appearance="outline">
                  <mat-label>{{'CODICE_PREATTIVAZIONE' | translate}}</mat-label>
                  <input formControlName="code" type="text" matInput
                    required/>
                  @if (checkForm(registrationForm, 'code'); as err) {
                    <mat-error>
                      {{err}}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="row-form">
                <mat-form-field appearance="outline">
                  <mat-label>{{'PASSWORD' | translate}}</mat-label>
                  <input formControlName="password"
                    type="password"
                    autocomplete="new-password"
                    matInput
                    required/>
                </mat-form-field>
              </div>
              <div class="row-form">
                <mat-form-field appearance="outline">
                  <mat-label>{{'RIPETI_PASSWORD' | translate}}</mat-label>
                  <input formControlName="samePassword"
                    type="password"
                    autocomplete="new-password"
                    matInput
                    required/>
                  @if (this.registrationForm?.get('samePassword')?.hasError('notSamePassword')) {
                    <mat-error>
                      {{ 'PASSWORD_NON_CORRISPONDONO' | translate}}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              @if (getPolicyList?.controls?.length) {
                <div class="my-4">
                  <div class="col-sm-12">
                    <h2 matDialogTitle>{{'TERMINI_E_CONDIZIONI' | translate}}</h2>
                  </div>
                  <div class="col-12" formArrayName="policy">
                    @for (formGroup of getPolicyList?.controls; track formGroup; let i = $index) {
                      <div [formGroupName]="i" class="form">
                        <mat-checkbox formControlName="value">
                          <div class="policy_description"
                          [innerHTML]="formGroup?.value?.description"></div>
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="my-4">
                <div class="col-sm-12">
                  <h2 matDialogTitle>{{'SOTTOSCRIVI_NEWSLETTER' | translate}}</h2>
                </div>
                <div class="col-12">
                  <mat-checkbox formControlName="subscriptionMailchimp">
                    <div class="policy_description">{{'SOTTOSCRIVI_NEWSLETTER_DESCRIPTION' | translate}}</div>
                  </mat-checkbox>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>

    <mat-dialog-actions align="end" class="d-block">
      <button class="button-confirm-base button-confirm-base-primary"
        [class.button-confirm-base-disabled]="!validForm()"
        (click)="register()" [disabled]="!validForm()"
      mat-button>{{'CONFERMA_UTENTE' | translate}}</button>
    </mat-dialog-actions>
  </div>
</div>

<ng-template #registrationComplete>
  <div class="mat-title font-weight-200 text-center">
    <h1 mat-dialog-title>
      {{ 'REGISTRAZIONE_OK' | translate }}.
    </h1>
    <div>
      {{ 'ISTRUZIONI_INVIATE' | translate }}
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button (click)="goToCatalog()"
    matDialogClose class="model-buttons-custom-model width-50">{{'TORNA_AL_CATALOGO' | translate | uppercase }}</button>
  </mat-dialog-actions>
</ng-template>
